@if (familyInviationService.executorInvitationDetails) {
  <div class="content_wrapper">
    <!-- Header section -->
    <div class="header_area">
      <div class="header_content d-flex justify-content-center">
        <div class="site_logo">
          <a href="../"><img class="logo_img" src="../assets/images/familycentral-logo.svg" width="150" height="150"
          alt="Family Central"></a>
        </div>
      </div>
    </div>
    <!-- Body content -->
    <div class="body-content">
      <div class="content-area">
        <div class="login_form">
          <!-- Executor first screen -->
          <div class="single_question_wrapper">
            <div class="question_content">
              <div class="question_heading">
                <h2 class="h2">Welcome,
                  <span class="text-capitalize">{{familyInviationService.executorInvitationDetails?.executorFirstName}}
                  {{familyInviationService.executorInvitationDetails?.executorLastName}}</span> </h2>
                  <p><span class="text-capitalize">{{familyInviationService.executorInvitationDetails?.firstName}}
                  {{familyInviationService.executorInvitationDetails?.lastName}}</span> has invited you to be their Executor.
                  Please set a strong password for your Family Central account. Click to learn more about
                  <a class="text_red" href="https://familycentral.com/">Family Central</a>.</p>
                </div>
                <div class="question_area">
                  @if (!familyInviationService.executorInvitationDetails?.isExist) {
                    <div>
                      <div class="input-group">
                        <input id="password" (keyup)="checkPassword()" [(ngModel)]="password"
                          class="form-control has-icon pass-icon" name="password"
                          [type]="isPassWordType ? 'password' : 'text'" placeholder="Password" required>
                          <button id="pass1" type="button" class="show_hide" aria-label="Show Password">
                            @if (isPassWordType) {
                              <img src="../assets/images/show-pass-icon.svg" alt=""
                                (click)="isPassWordType = !isPassWordType">
                            }
                            @if (!isPassWordType) {
                              <img src="../assets/images/hide-pass-icon.svg" alt=""
                                (click)="isPassWordType = !isPassWordType">
                            }
                          </button>
                        </div>
                        <div class="input-group">
                          <input id="confirmPassword" class="form-control has-icon pass-icon"
                            [(ngModel)]="confirmPwd" name="confirmPassword"
                            [type]="isConfirmPassWordType ? 'password' : 'text'"
                            placeholder="Confirm Password" required>
                            <button id="pass2" type="button" class="show_hide" aria-label="Show Password">
                              @if (isConfirmPassWordType) {
                                <img
                                  (click)="isConfirmPassWordType = !isConfirmPassWordType"
                                  src="../assets/images/show-pass-icon.svg" alt="">
                                }
                                @if (!isConfirmPassWordType) {
                                  <img
                                    (click)="isConfirmPassWordType = !isConfirmPassWordType"
                                    src="../assets/images/hide-pass-icon.svg" alt="">
                                  }
                                </button>
                              </div>
                              <div class="form-check my-3">
                                <input class="form-check-input" type="checkbox" id="check1" name="option1"
                                  [(ngModel)]="isCheck" value="something">
                                  <label for="check1" class="form-check-label fs_16">I agree to Family
                                    Central’s <a class="text-decoration-underline text_red"
                                  routerLink="/termsconditions" target="_blank">Terms & Conditions</a> and <a class="text-decoration-underline text_red"
                                  routerLink="/privacy-policy" target="_blank">Privacy
                                Policy</a>.</label>
                              </div>
                              @if (
                                !passwordPolicy?.hasLength ||
                                !passwordPolicy?.hasLower ||
                                !passwordPolicy?.hasCapital ||
                                !passwordPolicy?.hasNumber ||
                                !passwordPolicy?.hasSpecial
                                ) {
                                <div class="policy">
                                  <div>
                                    <span>Your password must contain:</span>
                                    <ul>
                                      @if (!passwordPolicy?.hasLength) {
                                        <li>
                                          <span>At least 8 characters</span>
                                        </li>
                                      }
                                      @if (!passwordPolicy?.hasLower) {
                                        <li>
                                          <span>Lower case letters (a-z)</span>
                                        </li>
                                      }
                                      @if (!passwordPolicy?.hasCapital) {
                                        <li>
                                          <span>Upper case letters (A-Z)</span>
                                        </li>
                                      }
                                      @if (!passwordPolicy?.hasNumber) {
                                        <li>
                                          <span>Numbers (0-9)</span>
                                        </li>
                                      }
                                      @if (!passwordPolicy?.hasSpecial) {
                                        <li>
                                          <span>At least 1 special character</span>
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                </div>
                              }
                              @if (isErrorState) {
                                <div style="color: red;font-size: 17px;">Password and Confirm Password must be match.</div>
                              }
                            </div>
                          }
                          <div class="main-wrapper d-flex justify-content-between align-items-center mt-3">
                            <div class="form-group submit_btn d-flex mbl-column mt-0 mb-0" >
                              <button type="button" name="next" class="border_btn"
                              (click)="DeclineInvitation()" style="padding: 9px 18px;">Decline invitation</button>
                            </div>
                            @if (!familyInviationService.executorInvitationDetails?.isExist) {
                              <div class="form-group submit_btn d-flex mbl-column mt-0 mb-0">
                                <button type="button" name="next" class="primary_btn"
                                  (click)="AcceptInvitation()" [disabled]="!isCheck" disableDuringAjax>Sign
                                In</button>
                              </div>
                            }
                            @if (familyInviationService.executorInvitationDetails?.isExist) {
                              <div>
                                <div class="form-group submit_btn d-flex mbl-column mt-0 mb-0 ">
                                  <button type="button" name="next" class="primary_btn"
                                  (click)="AcceptInvitation()" disableDuringAjax>Accept</button>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Executor first screen -->
                  </div>
                </div>
              </div>
            </div>
          }